@if (formGroup) {
  <form
    class="flex column vcenter"
    [formGroup]="formGroup"
    (submit)="onSubmit()"
  >
    <ng-template #titleTemplate>
      <h1>{{ heading }}</h1>
    </ng-template>
    <div class="title">
      <ng-container [ngTemplateOutlet]="titleTemplateRef || titleTemplate"></ng-container>
    </div>
    <ng-content></ng-content>
  </form>
}
